import React, { useEffect } from 'react';

import { Locale } from '@rover/constants/src/i18n/lingui.constants';
import dataLayer from '@rover/globals/dataLayer';
import { Flex } from '@rover/kibble/core';
import type { HomepageRebookingProfile } from '@rover/rsdk/src/apiClient/latest/model/homepageRebookingProfile';

import ServiceTypeDescription from '../../ServiceTypeDescription';

import RebookingProfiles from './RebookingProfiles';
import RebookingSearch from './RebookingSearch';

export type Props = {
  sitters: HomepageRebookingProfile[];
  services?: ServiceTypeDescription[];
  locale?: Locale;
};

const Rebooking: React.FC<Props> = ({ locale, sitters = [], services = [] }) => {
  useEffect(() => {
    dataLayer?.push({
      event: 'rebook-provider-view',
      moduleLocation: 'homepage',
      moduleLayout: 'horizontal',
      providers: sitters.map((s) => s.opk),
    });
  }, [sitters]);

  return sitters.length !== 0 ? (
    <Flex display={['none', 'flex']} justifyContent="center" mt="8x">
      <Flex width="100%" gap="4x">
        <RebookingProfiles locale={locale} sitters={sitters} />
        <RebookingSearch services={services} />
      </Flex>
    </Flex>
  ) : null;
};

export default Rebooking;
